export default __webpack_public_path__ + "static/media/mono.421ffcdc.svg";